import '../scss/taCoin.scss';
import menuModule from "./modules/menu.js";
import faqModule from "./modules/faqModule.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
import baguetteBox from 'baguettebox.js';
import shareModule from "./modules/shareModule.js";
import terminDescModule from "./modules/terminDescModule.js";
import mobileTableWidthSync from "./modules/mobileTableWidthSync.js";
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

(function ($) {
    $(document).ready(async function () {
        window.$ = jQuery;

        menuModule.init();
        faqModule.init();
        scrollUpModule.init();
        footerModule.init();
        shareModule.init();
        terminDescModule.init();
        mobileTableWidthSync.init();

        // Swiper-ы
        $('.posts-swiper').each(function (i, el) {

            new Swiper(this, {
                modules: [Navigation],
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: {
                    nextEl: '.button-next-' + el.dataset.swiperIndex,
                    prevEl: '.button-prev-' + el.dataset.swiperIndex,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    }
                }
            });
        })

        baguetteBox.run('.lightbox');

        $('[data-disclaimer-btn]').click(e => {
            e.preventDefault();
            $(e.target).closest('.disclaimer').toggleClass('disclaimer-open');
        });

        $('[data-hidden-rows-btn]').click(e => {
            e.preventDefault();
            $(e.target).closest('.hidden-rows').toggleClass('hidden-rows-open');
        });

        // Добавляем таблицам отзывчивости
        const tables = $('table');

        tables.each(function (tableIndex, table) {
            if (!$(table).closest('.table-responsive').length) {
                $(table).wrap('<div class="table-responsive"></div>')
            }
        })
        const syncTableScrollX = () => {
            const isMobile = window.innerWidth < 768;

            $('.table-responsive').each(function () {
                const $wrapper = $(this);
                const $scrollX = $wrapper.children('.table-responsive__scroll-x');
                const $table = $wrapper.children('table, .table_style');

                if (isMobile) {
                    if (!$scrollX.length && $table.length) {
                        $table.wrapAll('<div class="table-responsive__scroll-x"></div>');
                    }

                    const scrollXEl = $wrapper.children('.table-responsive__scroll-x')[0];
                    $wrapper.toggleClass('table-responsive--has-scroll-x', !!scrollXEl && scrollXEl.scrollWidth > scrollXEl.clientWidth + 1);
                } else {
                    if ($scrollX.length) {
                        $scrollX.children().unwrap();
                    }

                    $wrapper.removeClass('table-responsive--has-scroll-x');
                }
            });
        };

        syncTableScrollX();
        $(window).on('resize', syncTableScrollX);

        $(document).on('click', '.info-tooltip img', function () {
            if (window.innerWidth < 768) {
                $(this).closest('.info-tooltip').addClass('open')
                $('body').css('overflow-y', 'hidden')
            }
        })

        $(document).on('click', '[data-tooltip-close]', function () {
            if (window.innerWidth < 768) {
                $(this).closest('.info-tooltip').removeClass('open')
                $('body').css('overflow-y', 'unset')
            }
        })


        const shareBtns = document.querySelectorAll('[data-share-btn]')
        shareBtns.forEach(btn => {

            btn.addEventListener('click', (e) => {

                // если устройство с hover — ничего не делаем
                if (window.matchMedia('(hover: hover)').matches) {
                    return
                }

                e.stopPropagation()

                btn.classList.toggle('is-open')
            })

        })

        document.addEventListener('click', () => {
            document.querySelectorAll('.share-btn.is-open')
                .forEach(el => el.classList.remove('is-open'))
        })


        ////////// Фильтры //////////
        let timeFrame = '15m';
        let dataByTimeFrames = {};

        // Если выбрали новый таймфрейм
        $('[data-timeframe]').click(async function () {
            $('.timeframe').removeClass('selected');
            $(this).addClass('selected')

            timeFrame = $(this).data('timeframe');

            if (!dataByTimeFrames[timeFrame]) {
                await fetchData();
            }
            renderData();
        })

        const renderData = () => {

            if (dataByTimeFrames[timeFrame] === undefined) {
                // setTimeout(() => {
                //     renderData();
                // }, 100)

                return false;
            }

            const data = dataByTimeFrames[timeFrame];
            renderUpdateDate(data.updateDate);

            $('[data-ta="price"]').text(dataByTimeFrames['15m'].price)
            $('.coin-price-percent').removeClass('up, down').addClass(dataByTimeFrames['15m'].deltaClass)
            $('[data-ta="delta"]').text(dataByTimeFrames['15m'].delta)

            const speeds = ['speed-1', 'speed-2', 'speed-3', 'speed-4', 'speed-5'].join(' ');
            $('[data-ta="os-speed"]').removeClass(speeds).addClass(data.totalChartOscillators.speed)
            $('[data-ta="summary-speed"]').removeClass(speeds).addClass(data.totalChartSummary.speed)
            $('[data-ta="ma-speed"]').removeClass(speeds).addClass(data.totalChartMovingAverages.speed)

            $('[data-ta="os-speed"] [data-ta="sell"]').text(data.totalChartOscillators.sell)
            $('[data-ta="os-speed"] [data-ta="neutral"]').text(data.totalChartOscillators.neutral)
            $('[data-ta="os-speed"] [data-ta="buy"]').text(data.totalChartOscillators.buy)

            $('[data-ta="summary-speed"] [data-ta="sell"]').text(data.totalChartSummary.sell)
            $('[data-ta="summary-speed"] [data-ta="neutral"]').text(data.totalChartSummary.neutral)
            $('[data-ta="summary-speed"] [data-ta="buy"]').text(data.totalChartSummary.buy)

            $('[data-ta="ma-speed"] [data-ta="sell"]').text(data.totalChartMovingAverages.sell)
            $('[data-ta="ma-speed"] [data-ta="neutral"]').text(data.totalChartMovingAverages.neutral)
            $('[data-ta="ma-speed"] [data-ta="buy"]').text(data.totalChartMovingAverages.buy)

            $('.speedometers-items-item [data-ta="trend"]').removeClass(function (index, className) {
                return (className.match(/\bta-badge-\S+/g) || []).join(' ');
            });

            $('[data-ta="os-speed"] [data-ta="trend"]').addClass(data.totalChartOscillators.badge).text(data.totalChartOscillators.trend)
            $('[data-ta="summary-speed"] [data-ta="trend"]').addClass(data.totalChartSummary.badge).text(data.totalChartSummary.trend)
            $('[data-ta="ma-speed"] [data-ta="trend"]').addClass(data.totalChartMovingAverages.badge).text(data.totalChartMovingAverages.trend)

            // Таблица Осциляторов
            $('.os-block .ta-badge').removeClass(function (index, className) {
                return (className.match(/\bta-badge-\S+/g) || []).join(' ');
            });

            $('.os-block [data-ta="trend"]').text(data.oscillatorsTotal.trend).addClass(data.oscillatorsTotal.badge)
            $('.os-block [data-ta="sell"]').text(data.oscillatorsTotal.sell)
            $('.os-block [data-ta="neutral"]').text(data.oscillatorsTotal.neutral)
            $('.os-block [data-ta="buy"]').text(data.oscillatorsTotal.buy)

            for (let key in data.oscillators) {
                if (key === 'squeeze') {
                    $(`[data-ta="os-badge-${key}]`).text(data.oscillators.squeeze)
                } else {
                    $(`[data-ta="os-badge-${key}"]`)
                        .removeClass(function (index, className) {
                            return (className.match(/\bta-badge-\S+/g) || []).join(' ');
                        })
                        .addClass(data.oscillators[key].badge)
                        .text(data.oscillators[key].trend)

                    $(`[data-ta="os-scale-${key}"]`)
                        .css('left', (data.oscillators[key].percent >= 95 ? 95 : (data.oscillators[key].percent <= 5 ? 5 : data.oscillators[key].percent)) + '%')
                        .css('text-align', data.oscillators[key].percent >= 95 ? 'right' : (data.oscillators[key].percent <= 5 ? 'left' : 'center'))

                    $(`[data-ta="os-scale-value-${key}"]`)
                        .text(data.oscillators[key].value)
                }
            }


            // Таблица Mov Averages
            // Таблица Осциляторов
            $('.ma-block .ta-badge').removeClass(function (index, className) {
                return (className.match(/\bta-badge-\S+/g) || []).join(' ');
            });

            $('.ma-block [data-ta="trend"]').text(data.movingAveragesTotal.trend).addClass(data.movingAveragesTotal.badge)
            $('.ma-block [data-ta="sell"]').text(data.movingAveragesTotal.sell)
            $('.ma-block [data-ta="neutral"]').text(data.movingAveragesTotal.neutral)
            $('.ma-block [data-ta="buy"]').text(data.movingAveragesTotal.buy)

            for (let key in data.movingAverages) {
                for (let num in data.movingAverages[key]) {
                    // $(`[data-ta="${key}-${num}"]`).text(data.movingAverages[key].trend)
                    $(`[data-ta="${key}-${num}-value"]`).text(data.movingAverages[key][num].trend)
                    $(`[data-ta="${key}-${num}"]`).removeClass('up down').addClass(data.movingAverages[key][num].class)
                }
            }
            for (let key in data.pivotpoints) {
                $(`[data-ta="pivot-${key}"]`).text(data.pivotpoints[key])
            }
        }

        const onFilterSubmit = () => {
            // const summary = $('[name="summary"]:checked').map((i, el) => el.value).get();
            // const oscillators = $('[name="oscillators"]:checked').map((i, el) => el.value).get();
            // const movingAverages = $('[name="moving_averages"]:checked').map((i, el) => el.value).get();
            //
            // $.post(ajaxurl, {summary, oscillators, movingAverages, action: 'getTaTable', timeFrame}).then(response => {
            //     console.log(response)
            //     let html = '';
            //     response.data.forEach((row, index) => {
            //          html += `
            //         <tr>
            //             <td>${index + 1}</td>
            //             <td class="coin">
            //                 <img class="coin-image" src="${row.thumb_url}" alt="">
            //                 <span>${row.title} <span>${row.coin}</span></span>
            //             </td>
            //             <td>
            //                 <div class="ta-badge ${row.summaryBadge}">${row.summary}</div>
            //             </td>
            //             <td>
            //                 <div class="ta-badge ${row.movingAveragesBadge}">${row.movingAverages}</div>
            //             </td>
            //             <td>
            //                 <div class="ta-badge ${row.oscillatorsBadge}">${row.oscillators}</div>
            //             </td>
            //         </tr>
            //         `;
            //     })
            //
            //     $('#ta-table-body').html(html)
            // });
            //
            // console.log(summary, oscillators, movingAverages);

        }

        // setInterval(() => {
        //     fetchData()
        // }, 5000)


        const renderUpdateDate = (date = null) => {
            const dateEl = $('[data-update-date]');

            if (!date) {
                date = dateEl.data('updateDate');
            }

            const offset = -new Date(date + 'Z').getTimezoneOffset() / 60;

            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const localDate = (new Date(date + 'Z')).toLocaleTimeString('ru-RU', {
                timeZone,
                hour: '2-digit',
                minute: '2-digit',
            }) + ` UTC${offset >= 0 ? '+' : ''}${offset}`;

            dateEl.text(localDate)
        }

        await fetchData();


        setInterval(async () => {
            await fetchData();
        }, 10000)

        async function fetchData() {
            const postId = $('meta[name="post-id"]').attr('content')

            const r = await $.post(ajaxurl, {action: 'ajaxGetTaCoins', postId});
            const {data} = r;
            dataByTimeFrames = {...data};
            renderData();

            return data;
        }

    });
}(jQuery));


